export default __webpack_public_path__ + "static/media/1984.a26190a6.png";